import { useApolloClient } from '@apollo/client';
import {
  ArchiveBoxXMarkIcon,
  CalendarIcon,
  DocumentArrowDownIcon,
  EnvelopeIcon,
  GiftIcon,
} from '@heroicons/react/20/solid';
import { ACTION_ORDER_STATUS } from '@retainerclub/admin-api';
import { useApp, useElevatedAccess } from '@retainerclub/hooks';
import PropTypes from 'prop-types';
import { SelectMenuItem } from '../../../shared';
import { orderHasHsaInvoiceItems } from '../helpers/hsaInvoice';

function OrderShowActions({
  order,
  onOpenPlanStartModal,
  onOpenConvertModal,
  onGenerateDisputePackage,
  onGenerateHsaInvoice,
  onResendSubscriptionEmail = null,
}) {
  const client = useApolloClient();

  const { isAdmin } = useApp();
  const { hasElevatedAccess, isSuperAdmin } = useElevatedAccess();

  async function changeState(action) {
    await client.mutate({
      mutation: ACTION_ORDER_STATUS,
      variables: {
        input: {
          input: {
            id: order.id,
            action,
          },
          clientMutationId: crypto.randomUUID(),
        },
      },
    });
  }

  const hasPlanItems = order.orderItems?.some(
    (item) => item.product?.productType === 'plan',
  );

  const hasNoProductionOrders =
    !order.productionOrders || order.productionOrders.length === 0;
  const isPending = order.state === 'pending';

  const showPlanStartAction =
    isAdmin && hasPlanItems && hasNoProductionOrders && isPending;
  const showHsaInvoiceAction = isAdmin && orderHasHsaInvoiceItems(order);

  return (
    <>
      {order.awaitingSubscriptionAcknowledgment &&
        onResendSubscriptionEmail && (
          <SelectMenuItem
            onClick={onResendSubscriptionEmail}
            icon={EnvelopeIcon}
          >
            Resend Plan Terms Email
          </SelectMenuItem>
        )}
      {showPlanStartAction && (
        <SelectMenuItem onClick={onOpenPlanStartModal} icon={CalendarIcon}>
          Set Plan Start Delay
        </SelectMenuItem>
      )}
      {isAdmin && (order.state === 'pending' || order.state === 'complete') && (
        <SelectMenuItem
          onClick={() => changeState('deliver')}
          icon={ArchiveBoxXMarkIcon}
        >
          Mark as Delivered
        </SelectMenuItem>
      )}
      {hasElevatedAccess && !order.courtesyOrder && order.paidByPartner && (
        <SelectMenuItem onClick={onOpenConvertModal} icon={GiftIcon}>
          Convert to Courtesy
        </SelectMenuItem>
      )}
      {isSuperAdmin && (
        <SelectMenuItem
          onClick={onGenerateDisputePackage}
          icon={DocumentArrowDownIcon}
        >
          Dispute Package
        </SelectMenuItem>
      )}
      {showHsaInvoiceAction && (
        <SelectMenuItem
          onClick={onGenerateHsaInvoice}
          icon={DocumentArrowDownIcon}
        >
          Purchase Receipt
        </SelectMenuItem>
      )}
    </>
  );
}

OrderShowActions.propTypes = {
  order: PropTypes.object.isRequired,
  onOpenPlanStartModal: PropTypes.func.isRequired,
  onOpenConvertModal: PropTypes.func,
  onGenerateDisputePackage: PropTypes.func.isRequired,
  onGenerateHsaInvoice: PropTypes.func.isRequired,
  onResendSubscriptionEmail: PropTypes.func,
};

export default OrderShowActions;
